import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Contact from './pages/Contact';
import Features from './pages/Features';
import Blog from './pages/Blog';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import FAQ from './pages/FAQ';

// SEO Deeplink Pages
import FreeGSTSoftware from './pages/FreeGSTSoftware';
import AIInvoiceProcessing from './pages/AIInvoiceProcessing';
import GSTAutomationForCA from './pages/GSTAutomationForCA';
import CaseStudies from './pages/CaseStudies';
import Resources from './pages/Resources';
import GSTComplianceGuide from './pages/GSTComplianceGuide';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <GoogleAnalytics />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/faq" element={<FAQ />} />

            {/* SEO Deeplink Pages */}
            <Route path="/free-gst-software" element={<FreeGSTSoftware />} />
            <Route path="/ai-invoice-processing" element={<AIInvoiceProcessing />} />
            <Route path="/gst-automation-for-ca" element={<GSTAutomationForCA />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/gst-compliance-guide" element={<GSTComplianceGuide />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;